// extracted by mini-css-extract-plugin
export default {"container":"StaffEmpty_container__o5kjq","text":"StaffEmpty_text__jG16W","btnWrapper":"StaffEmpty_btnWrapper__3e9Fg"};